module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABHklEQVQ4T6WTsUrEQBCGd4aks7lasRYlkOS2OfQFrEJAm6ti4wvkOfICVkljJQmpfAHFZlMFxVq0vsYuYVZGbo81nHKyW+3M/PMxMzsLYnKCIJh5nnektT5AxD0OE9EnALyP4/ja9/3KTgHLQCnlgoiOhRC239ZrRHxRSj0xlwNGiPP5/FxrvT+taJsNAB9d190z5BsgpTwlopNdko0GEZ+VUo/APfu+f/FH2b9x9TAMdxBF0QIAAltVVdWyruuHtm3f2J8kyWGapmdZlt3+GIjWPYRheImIMzvACXmeXxdFccN+czdAoyWiFcRxfCWE8Kd1Ggj7GTRNXusHd4BzC9uGWJblsmma3Ybo/IzOi7SeptsqG4jLZ9qswX+/8xcNsriR5AG9qAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login/icon_delete.png
// module id = FUMz
// module chunks = 19